import React, { createContext, useState, useContext } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../services/firebase";

const SearchContext = createContext();

const searchProducts = async (searchTerm) => {
  try {
    const productsRef = collection(db, "products");

    const productsQuery = query(
      productsRef,
      where("name", ">=", searchTerm),
      where("name", "<=", searchTerm + "\uf8ff")
    );

    const lowercaseProductsQuery = query(
      productsRef,
      where("name_lowercase", ">=", searchTerm),
      where("name_lowercase", "<=", searchTerm + "\uf8ff")
    );

    const lowercaseBrandQuery = query(
      productsRef,
      where("brand_lowercase", ">=", searchTerm),
      where("brand_lowercase", "<=", searchTerm + "\uf8ff")
    );

    const categoryQuery = query(
      productsRef,
      where("category", ">=", searchTerm),
      where("category", "<=", searchTerm + "\uf8ff")
    );

    const subCategoryQuery = query(
      productsRef,
      where("subCategory", ">=", searchTerm),
      where("subCategory", "<=", searchTerm + "\uf8ff")
    );

    const departmentQuery = query(
      productsRef,
      where("department", ">=", searchTerm),
      where("department", "<=", searchTerm + "\uf8ff")
    );

    const tagsQuery = query(
      productsRef,
      where("tags", "array-contains", searchTerm)
    );

    const [
      productsSnapshot,
      lowercaseProductsSnapshot,
      categoriesSnapshot,
      subCategorySnapshot,
      departmentSnapshot,
      tagsSnapshot,
      lowercaseBrandSnapshot,
    ] = await Promise.all([
      getDocs(lowercaseProductsQuery),
      getDocs(productsQuery),
      getDocs(categoryQuery),
      getDocs(subCategoryQuery),
      getDocs(departmentQuery),
      getDocs(tagsQuery),
      getDocs(lowercaseBrandQuery),
    ]);

    const products = [];
    const name_lowercase = [];
    const categories = [];
    const subCategories = [];
    const departments = [];
    const tagResults = [];
    const brand_lowercase = [];

    productsSnapshot.forEach((doc) => {
      products.push({ id: doc.id, ...doc.data() });
    });
    lowercaseProductsSnapshot.forEach((doc) =>
      name_lowercase.push({ id: doc.id, ...doc.data() })
    );
    categoriesSnapshot.forEach((doc) =>
      categories.push({ id: doc.id, ...doc.data() })
    );
    subCategorySnapshot.forEach((doc) =>
      subCategories.push({ id: doc.id, ...doc.data() })
    );
    departmentSnapshot.forEach((doc) =>
      departments.push({ id: doc.id, ...doc.data() })
    );
    tagsSnapshot.forEach((doc) =>
      tagResults.push({ id: doc.id, ...doc.data() })
    );
    lowercaseBrandSnapshot.forEach((doc) =>
      brand_lowercase.push({ id: doc.id, ...doc.data() })
    );

    const combinedResults = [
      ...new Set([
        ...products,
        ...name_lowercase,
        ...categories,
        ...subCategories,
        ...departments,
        ...tagResults,
        ...brand_lowercase,
      ]),
    ];

    return combinedResults;
  } catch (error) {
    console.error("Error searching products:", error);
    return [];
  }
};

export const SearchProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const handleSearch = async (term) => {
    setSearchTerm(term);
    const results = await searchProducts(term.toLowerCase());

    setSuggestions(results);
  };

  return (
    <SearchContext.Provider value={{ searchTerm, suggestions, handleSearch }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => useContext(SearchContext);
